import type { Request } from '../../../index'
import type {
  DeleteSurveyParams,
} from 'app/common/types/surveys'

type DeleteSurveyResultDto = { result: 'success' }

type SurveyUrlParams = {
  id: string
}

export const convertParams = (
  params: DeleteSurveyParams,
): [Record<string, never>, SurveyUrlParams] => [{}, { id: params.surveyId }]
export const convertResult = (data: DeleteSurveyResultDto): boolean => data.result === 'success'

export const DELETE_SURVEY: Request<DeleteSurveyParams, boolean, SurveyUrlParams> = [
  'food/surveys/{id}',
  'delete',
  ['data'],
]
